var _defs, _circle, _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCscmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2f2f2f;\n        stroke: #2f2f2f;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.5,
    cy: 26.5,
    r: 22.5
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "Vector_Smart_Object",
    "data-name": "Vector Smart Object",
    x: 16,
    y: 14,
    width: 24,
    height: 28,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAcCAYAAAB75n/uAAADAUlEQVRIia2WW6hVVRSGv6VGYlpSGRJKV0S6WNjFhIKeLIrKsBQJguwhAh8KX4IUegiCnvKhC/SUBUVBWkEXkbAI6yidBJUS0aPSjbLUg2WJxy9G/FtWsM/unI0DFnONOeYcY85/jH+sRVvUOeof9icf0kUmdKbU2cB2YArwfaY3AEeBg8DJ6H8CP2TckPm9wMXdAnScz1SHc+6f1MF6iW27ulU9En2/+k2N0Y+on9W6rjdQzwM2A9OANcDAqCfpQwqit4DLsnUqMLd1s2eAmVEnR58efXr0yT3DBpYX1V9z3XreVH9r6evU3/N+WH29Zav5D0aDaFLGPU3TzOgXBvUFYHY324Ruk2dSJvXjSz0XeBZYkBxO7LW45IkxOJ2nvqTuVk91oWLlcLF6fnvfqDdQi3DbgFmprg6cI8AO4G3gx1TdkhBtffYWUffV/l4QzQeuAopgXwO7qxiAc4DFgagjxZ3Xwvg6zOXAbcCqseTgOeBBYHmwHgY2Aq8Ah+LsVuBp4GzgBPBl7DeNJUCd6EZgLfAGcBxYBzzQWvM5cHVI+TjwUCAcV5lWYxsCNoXNS4P/w8Ac4CNgMPbTMt4yrWqrEl3YNE2n2V0IvAs8BjwKHGtvGC/RKnEfA0+qC9UrgPcDz0Ds/5FeAYYzTst4UdaPJCcV6JOceFnmm+SsEl3t/lSvAN9lnJfyrNLcAtwJrIi9knovUC3/FuAr4H5gK3DNv1zoxeQijHpCXRX23p0uu0u9T71ZvScfoQPq0vhbof6iru0EON5qv+3n79hfVneqQ+rtaRdtGcx8Of1CXa2eVOc26iPAJT2gqjZwaer+nbSJgum6tIehPJuTpyrb94BXm6ZZ2cPvaZguUA+q3waWv9RP01HLPkPdoR5V72qtnfq/zltBro+DgWB+LD8Dd6h7k5fKzx71Z/XKMTtvBVmQILvi+EByUKddlERXy7523M5bQW7ICQ+py9Sn1OUpin3149a381aQWeoWdUTdlFtsTMs4M6KepT6fXNQtuhMW+AflmeMsCBAD6QAAAABJRU5ErkJggg=="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCscmall);
export default __webpack_public_path__ + "static/media/cscmall.3515101d.svg";
export { ForwardRef as ReactComponent };